import { File } from "../classes/File.js";
function normalizePolicyChangeTimestamp(value) {
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : undefined;
    }
    if (typeof value === "bigint") {
        const numeric = Number(value);
        return Number.isSafeInteger(numeric) ? numeric : undefined;
    }
    if (typeof value === "string") {
        const numeric = Number(value);
        return Number.isFinite(numeric) ? numeric : undefined;
    }
    if (!value || typeof value !== "object") {
        return undefined;
    }
    const longLike = value;
    if (longLike.$numberLong !== undefined) {
        return normalizePolicyChangeTimestamp(longLike.$numberLong);
    }
    if (typeof longLike.toNumber === "function") {
        const numeric = longLike.toNumber();
        if (Number.isFinite(numeric)) {
            return numeric;
        }
    }
    if (typeof longLike.high === "number" && typeof longLike.low === "number") {
        const high = BigInt(longLike.unsigned ? longLike.high >>> 0 : longLike.high);
        const low = BigInt(longLike.low >>> 0);
        const combined = (high << 32n) + low;
        const numeric = Number(combined);
        return Number.isSafeInteger(numeric) ? numeric : undefined;
    }
    if (typeof longLike.toString === "function") {
        const serialized = longLike.toString();
        if (/^-?\d+$/.test(serialized)) {
            return normalizePolicyChangeTimestamp(serialized);
        }
    }
}
export const userHydration = {
    keyMapping: {
        _id: "id",
        display_name: "displayName",
        last_acknowledged_policy_change: "lastAcknowledgedPolicyChange",
    },
    functions: {
        id: (user) => user._id,
        username: (user) => user.username,
        discriminator: (user) => user.discriminator,
        displayName: (user) => user.display_name,
        showTierBadge: (user) => user.show_tier_badge,
        lastAcknowledgedPolicyChange: (user) => normalizePolicyChangeTimestamp(user.last_acknowledged_policy_change),
        relationship: (user) => user.relationship,
        relations: () => null,
        online: (user) => user.online,
        privileged: (user) => user.privileged,
        badges: (user) => user.badges,
        flags: (user) => user.flags,
        avatar: (user, ctx) => new File(ctx, user.avatar),
        status: (user) => user.status,
        bot: (user) => user.bot,
        tier: (user) => user.tier,
    },
    initialHydration: () => ({
        relationship: "None",
    }),
};
/**
 * Badges available to users
 */
export var UserBadges;
(function (UserBadges) {
    UserBadges[UserBadges["Developer"] = 1] = "Developer";
    UserBadges[UserBadges["Translator"] = 2] = "Translator";
    UserBadges[UserBadges["Supporter"] = 4] = "Supporter";
    UserBadges[UserBadges["ResponsibleDisclosure"] = 8] = "ResponsibleDisclosure";
    UserBadges[UserBadges["Founder"] = 16] = "Founder";
    UserBadges[UserBadges["PlatformModeration"] = 32] = "PlatformModeration";
    UserBadges[UserBadges["ActiveSupporter"] = 64] = "ActiveSupporter";
    UserBadges[UserBadges["Paw"] = 128] = "Paw";
    UserBadges[UserBadges["EarlyAdopter"] = 256] = "EarlyAdopter";
    UserBadges[UserBadges["ReservedRelevantJokeBadge1"] = 512] = "ReservedRelevantJokeBadge1";
    UserBadges[UserBadges["ReservedRelevantJokeBadge2"] = 1024] = "ReservedRelevantJokeBadge2";
    UserBadges[UserBadges["Official"] = 2048] = "Official";
    UserBadges[UserBadges["Verified"] = 4096] = "Verified";
})(UserBadges || (UserBadges = {}));
/**
 * Flags attributed to users
 */
export var UserFlags;
(function (UserFlags) {
    UserFlags[UserFlags["Suspended"] = 1] = "Suspended";
    UserFlags[UserFlags["Deleted"] = 2] = "Deleted";
    UserFlags[UserFlags["Banned"] = 4] = "Banned";
})(UserFlags || (UserFlags = {}));
